import React from 'react'
import renderHtml from 'react-render-html'

const EventEntry = ({ schedule }) => {
  const { title, marketingLink, isInternalLink } = schedule
  return (
    <div className="event-entry">
      {marketingLink ? (
        <a
          href={marketingLink}
          target={!isInternalLink ? '_blank' : '_self'}
          rel="noopener noreferrer"
          className="event-cta-link"
        >
          {renderHtml(title)}
        </a>
      ) : (
        <p className="event-title">{renderHtml(title)}</p>
      )}
    </div>
  )
}

export default EventEntry
